export default "__VITE_ASSET__DMo6_Fdt__"